// extracted by mini-css-extract-plugin
export var main = "container-module--main--BW2TZ";
export var brgraphic = "container-module--brgraphic--jDMcQ";
export var title = "container-module--title--RTfIv";